import React from "react";

import Header from "./components/Header";
import Footer from "./components/Footer/Footer.jsx";
// import Chatbot from "./pages/Chatbot/chatbot.jsx";
import ScrollToTopButton from "./pages/ScrollToTopButton/ScrollToTopButton";

import AppRoutes from "./routes/AppRoutes";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop.jsx";

function App() {
  return (
    <>
      <Header theme="light" />
      <AppRoutes />
      <Footer />
      <ScrollToTop />

      {/* <Chatbot /> */}
      <ScrollToTopButton />
    </>
  );
}

export default App;
